(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown-timer"] && !Shopify.designMode) return;
  try {
    // Counts down to midnight in the visitor's own timezone and rolls straight
  // into the next day. Derived from the clock each tick, so there is nothing
  // stored and nothing to fall back to: reloading, or crossing midnight with
  // the page open, both land on the correct value.
  (() => {
    const start = () => {
      const el = document.getElementById('countdown-display');
      if (!el) return;

      const pad = (n) => String(n).padStart(2, '0');

      const tick = () => {
        const now = new Date();
        const midnight = new Date(now);
        midnight.setHours(24, 0, 0, 0); // 24:00 today === 00:00 tomorrow, local

        const left = Math.max(0, Math.floor((midnight - now) / 1000));
        const h = Math.floor(left / 3600);
        const m = Math.floor((left % 3600) / 60);
        const s = left % 60;
        el.textContent = `${pad(h)}:${pad(m)}:${pad(s)}`;
      };

      tick();
      setInterval(tick, 1000);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["popup-button"] && !Shopify.designMode) return;
  try {
    (function() {
    const triggers = document.querySelectorAll('[data-popup-trigger]');
    
    triggers.forEach(trigger => {
      const popupId = trigger.getAttribute('data-popup-trigger');
      const modal = document.querySelector(`[data-popup-modal="${popupId}"]`);
      const closeButtons = modal ? modal.querySelectorAll(`[data-popup-close="${popupId}"]`) : [];
      const tabs = modal ? modal.querySelectorAll(`[data-tab][data-popup-id="${popupId}"]`) : [];
      const panels = modal ? modal.querySelectorAll(`[data-panel][data-popup-id="${popupId}"]`) : [];

      if (!modal) return;

      trigger.addEventListener('click', () => {
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });

      closeButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        });
      });

      modal.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }
      });

      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const tabNum = tab.getAttribute('data-tab');
          
          tabs.forEach(t => t.classList.remove('popup-modal__tab--active'));
          tab.classList.add('popup-modal__tab--active');
          
          panels.forEach(panel => {
            if (panel.getAttribute('data-panel') === tabNum) {
              panel.classList.add('popup-modal__panel--active');
            } else {
              panel.classList.remove('popup-modal__panel--active');
            }
          });
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-accordion"] && !Shopify.designMode) return;
  try {
    // Opens the ingredient popup with a native <dialog>: modal behaviour, Esc to
  // close and focus handling come for free, no library needed.
  (() => {
    if (window.__accordionPopupBound) return;
    window.__accordionPopupBound = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('.accordion-popup-trigger[aria-haspopup="dialog"]');
      if (trigger) {
        const id = trigger.getAttribute('data-popup-trigger');
        const dialog = document.querySelector(`.accordion-popup[data-popup="${id}"]`);
        if (dialog) {
          event.preventDefault();
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
        }
        return;
      }

      if (event.target.closest('[data-popup-close]')) {
        const dialog = event.target.closest('.accordion-popup');
        if (dialog) dialog.close ? dialog.close() : dialog.removeAttribute('open');
        return;
      }

      // Click outside the panel closes it.
      const openDialog = event.target.classList?.contains('accordion-popup') ? event.target : null;
      if (openDialog) openDialog.close ? openDialog.close() : openDialog.removeAttribute('open');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["quantity-break"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quantity-break')) {
    customElements.define(
      'quantity-break',
      class QuantityBreak extends HTMLElement {
        connectedCallback() {
          this.inputs = this.querySelectorAll('.qb__input');
          this.hiddenQty = this.querySelector('.quantity-preset-input');
          this.syncQuantity();
          this.inputs.forEach((input) => {
            input.addEventListener('change', () => this.onChange(input));
          });
          this.bindForm();
          this.unitPrice = Number(this.dataset.unitPrice || 0);
          this.unitCompare = Number(this.dataset.unitCompare || 0);
          this.giftTotal = Number(this.dataset.giftTotal || 0);
          document.addEventListener('variant:update', this.onVariantUpdate);
          requestAnimationFrame(() => this.updateMainPrice());
        }

        disconnectedCallback() {
          document.removeEventListener('variant:update', this.onVariantUpdate);
          if (this.form && this.submitHandler) {
            this.form.removeEventListener('submit', this.submitHandler, true);
          }
        }

        get selectedInput() {
          return this.querySelector('.qb__input:checked');
        }

        get selectedOption() {
          return this.selectedInput?.value || 'classic';
        }

        get isMultiBuy() {
          return this.selectedOption !== 'classic';
        }

        get isBundle() {
          return this.isMultiBuy;
        }

        get selectedQuantity() {
          return Number(this.selectedInput?.dataset.quantity || 1);
        }

        shouldAddGifts() {
          return this.dataset.enableFreeGifts === 'true' && this.isMultiBuy;
        }

        get priceDisplayMode() {
          return this.dataset.priceDisplay || 'total';
        }

        floorUnitCents(cents, qty) {
          if (qty <= 1) return cents;
          let unit = Math.floor(cents / qty);
          if (this.dataset.dropDecimalFloor === 'true') {
            unit = Math.floor(unit / 100) * 100;
          }
          return unit;
        }

        normalizeCompare(cents) {
          if (this.dataset.roundCompare === 'true') {
            return Math.round(cents);
          }
          return cents;
        }

        optionTotals(option) {
          const unitPrice = this.unitPrice;
          let unitCompare = this.unitCompare;
          if (!unitCompare || unitCompare <= unitPrice) unitCompare = unitPrice;

          if (option === 'classic') {
            return {
              price: unitPrice,
              compare: unitCompare > unitPrice ? this.normalizeCompare(unitCompare) : 0,
            };
          }

          const qty =
            option === 'triple'
              ? Number(this.dataset.qtyTriple || 3)
              : Number(this.dataset.qtyBundle || 2);
          const percent =
            option === 'triple'
              ? Number(this.dataset.discountPercent3 || 0)
              : Number(this.dataset.discountPercent || 0);
          const fixed =
            option === 'triple'
              ? Number(this.dataset.fixedTriple || 0)
              : Number(this.dataset.fixedBundle || 0);

          let price = unitPrice * qty;
          if (fixed > 0) {
            price = fixed;
          } else if (percent > 0) {
            price = Math.round((price * (100 - percent)) / 100);
          }

          let compare = unitCompare * qty;

          if (this.priceDisplayMode === 'unit' && qty > 1) {
            price = this.floorUnitCents(price, qty);
          }
          compare = this.normalizeCompare(compare);

          return { price, compare: compare > price ? compare : 0 };
        }

        onChange(input) {
          this.querySelectorAll('.qb__bar').forEach((bar) => {
            bar.classList.toggle('is-selected', bar.contains(input) && input.checked);
          });
          this.syncQuantity();
          this.updateMainPrice();
        }

        syncQuantity() {
          const qty = Number(this.selectedInput?.dataset.quantity || 1);
          if (this.hiddenQty) this.hiddenQty.value = String(qty);
          const form = this.getForm();
          if (!form) return;
          // The theme adds the MAIN product itself from the form's quantity field.
          // Make sure exactly one quantity input exists INSIDE the form and carries
          // the selected quantity, so the bundle option adds 2 (not the default 1).
          let qtyFields = form.querySelectorAll('input[name="quantity"]');
          if (!qtyFields.length) {
            const hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = 'quantity';
            form.appendChild(hidden);
            qtyFields = form.querySelectorAll('input[name="quantity"]');
          }
          qtyFields.forEach((field) => {
            field.value = String(qty);
          });
          const selector = form.querySelector('quantity-selector-component input, .quantity-input, input.quantity__input');
          if (selector) selector.value = String(qty);
        }

        getForm() {
          const section = this.closest('.shopify-section');
          return (
            section?.querySelector('product-form-component form') ||
            document.querySelector('product-form-component form[action*="/cart/add"]')
          );
        }

        bindForm() {
          this.form = this.getForm();
          if (!this.form) return;
          this.submitHandler = (event) => this.onSubmit(event);
          this.form.addEventListener('submit', this.submitHandler, true);
          this.syncQuantity();
        }

        onSubmit() {
          this.syncQuantity();
          if (!this.shouldAddGifts()) return;
          const giftIds = this.parseGiftIds();
          if (!giftIds.length) return;
          const giftQty = this.selectedQuantity;

          let started = false;
          const start = () => {
            if (started) return;
            started = true;
            document.removeEventListener('cart:update', onCartUpdate);
            this.addGifts(giftIds, giftQty);
          };
          const onCartUpdate = (event) => {
            if (event.detail?.data?.source === 'quantity-break') return;
            start();
          };

          document.addEventListener('cart:update', onCartUpdate);
          setTimeout(start, 2000);
        }

        parseGiftIds() {
          try {
            return JSON.parse(this.dataset.giftVariantIds || '[]')
              .map((id) => Number(id))
              .filter((id) => id > 0);
          } catch (error) {
            return [];
          }
        }

        async addGifts(giftIds, giftQty) {
          if (this._giftAddInFlight) return;
          this._giftAddInFlight = true;
          setTimeout(() => {
            this._giftAddInFlight = false;
          }, 1200);

          const qty = Math.max(1, Number(giftQty) || 1);
          const items = giftIds.map((id) => ({
            id,
            quantity: qty,
            properties: { _quantity_break_gift: 'true' },
          }));

          const cartItemsComponent = document.querySelector('cart-items-component');
          const sectionId = cartItemsComponent?.dataset.sectionId;
          const body = { items };
          if (sectionId) {
            body.sections = sectionId;
            body.sections_url = window.location.pathname;
          }

          try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(body),
            });
            const cartData = await response.json();
            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cartData,
                  sourceId: this.id || 'quantity-break',
                  data: {
                    source: 'quantity-break',
                    itemCount: giftIds.length,
                    didError: Boolean(cartData.status),
                    sections: cartData.sections,
                  },
                },
              })
            );
          } catch (error) {
            console.error('Quantity break gift add failed', error);
          }
        }

        onVariantUpdate = (event) => {
          const variant = event.detail?.resource;
          const productId = String(event.detail?.data?.productId || '');
          if (!variant || !productId || productId !== String(this.dataset.productId)) return;

          const unitPrice = this.toCents(variant.price);
          let unitCompare = this.toCents(variant.compare_at_price);
          if (!unitCompare || unitCompare <= unitPrice) unitCompare = unitPrice;
          this.unitPrice = unitPrice;
          this.unitCompare = unitCompare;

          ['classic', 'bundle', 'triple'].forEach((option) => {
            const { price, compare } = this.optionTotals(option);
            this.writePrice(`[data-qb-price="${option}"]`, price);
            this.writeCompare(`[data-qb-compare="${option}"]`, compare, price);
          });

          const bundleSave = this.optionTotals('bundle');
          const tripleSave = this.optionTotals('triple');
          const saveBundle = (bundleSave.compare || this.unitCompare * Number(this.dataset.qtyBundle || 2)) - bundleSave.price;
          const saveTriple = (tripleSave.compare || this.unitCompare * Number(this.dataset.qtyTriple || 3)) - tripleSave.price;

          const saveEl = this.querySelector('[data-qb-save]:not([data-qb-save="triple"])');
          if (saveEl) {
            if (saveBundle > 0) {
              saveEl.hidden = false;
              saveEl.textContent = (this.dataset.saveTemplate || 'SAVE [amount]').replace(
                '[amount]',
                this.formatMoney(saveBundle)
              );
            } else {
              saveEl.hidden = true;
            }
          }

          const saveElTriple = this.querySelector('[data-qb-save="triple"]');
          if (saveElTriple) {
            if (saveTriple > 0) {
              saveElTriple.hidden = false;
              saveElTriple.textContent = (this.dataset.saveTemplate || 'SAVE [amount]').replace(
                '[amount]',
                this.formatMoney(saveTriple)
              );
            } else {
              saveElTriple.hidden = true;
            }
          }

          requestAnimationFrame(() => this.updateMainPrice());
        };

        get mainPriceEls() {
          const scope = this.closest('.shopify-section') || document;
          const pp = scope.querySelector('product-price');
          if (!pp) return null;
          return {
            price: pp.querySelector('.price'),
            compare: pp.querySelector('.compare-at-price'),
          };
        }

        // Total shown on top of the page for the currently selected option.
        // compare = (unit compare-at x quantity) + value of all free gifts.
        selectedTotals() {
          return this.optionTotals(this.selectedOption === 'bundle3' ? 'triple' : this.selectedOption);
        }

        updateMainPrice() {
          const els = this.mainPriceEls;
          if (!els || !els.price) return;
          const { price, compare } = this.selectedTotals();
          els.price.textContent = this.formatMoney(price);
          if (els.compare) {
            const group = els.compare.closest('[role="group"]') || els.compare;
            if (compare > price) {
              els.compare.textContent = this.formatMoney(compare);
              group.style.removeProperty('display');
            } else {
              group.style.display = 'none';
            }
          }
        }

        writePrice(selector, cents) {
          const el = this.querySelector(selector);
          if (el) el.textContent = this.formatMoney(cents);
        }

        writeCompare(selector, compareCents, priceCents) {
          const el = this.querySelector(selector);
          if (!el) return;
          if (compareCents > priceCents) {
            el.hidden = false;
            el.textContent = this.formatMoney(compareCents);
          } else {
            el.hidden = true;
          }
        }

        toCents(value) {
          if (value == null || value === '') return 0;
          if (typeof value === 'number') return Math.round(value);
          const raw = String(value).trim();
          if (raw.includes('.') || raw.includes(',')) {
            return Math.round(parseFloat(raw.replace(',', '.').replace(/[^\d.]/g, '')) * 100) || 0;
          }
          return parseInt(raw.replace(/\D/g, ''), 10) || 0;
        }

        formatMoney(cents) {
          let value = cents;
          if (this.dataset.dropDecimalFloor === 'true' && this.priceDisplayMode === 'unit') {
            value = Math.floor(value / 100) * 100;
          }
          let formatted;
          if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
            formatted = window.Shopify.formatMoney(value, this.dataset.moneyFormat);
          } else {
            formatted = this.renderMoneyFormat(value, this.dataset.moneyFormat);
          }
          if (this.dataset.hideZeros === 'true') {
            formatted = formatted.replace(/([.,]00)\b/g, '');
          }
          return formatted;
        }

        // Fallback money renderer for themes that don't expose Shopify.formatMoney.
        // Understands the standard {{amount*}} placeholders so the currency symbol is kept.
        renderMoneyFormat(cents, format) {
          format = format || '${{amount}}';
          const build = (precision, thousands, decimal) => {
            const num = (Math.round(cents) / 100).toFixed(precision);
            let [int, dec] = num.split('.');
            int = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
            return dec ? int + decimal + dec : int;
          };
          return format.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, name) => {
            switch (name) {
              case 'amount': return build(2, ',', '.');
              case 'amount_with_comma_separator': return build(2, '.', ',');
              case 'amount_with_space_separator': return build(2, ' ', ',');
              case 'amount_no_decimals': return build(0, ',', '.');
              case 'amount_no_decimals_with_comma_separator': return build(0, '.', ',');
              case 'amount_no_decimals_with_space_separator': return build(0, ' ', ',');
              default: return build(2, ',', '.');
            }
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
